import { useFeature } from '@growthbook/growthbook-react';
import FEATURES from '../constants/featureToggling';

export const useIsUnifiedPromoBonusSystemEnabled = () => {
  return useFeature(FEATURES.USE_PROMO_BONUS_SYSTEM).on;
};
